import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import type { FieldFormProps } from '@helpcenter/field-types';
import { FieldBase } from 'view/common/fields/field-base';
import { Checkbox } from '@atlaskit/checkbox/checkbox';
import { normalizeMultiCheckboxValue } from '@atlassian/jsm-ui-modifications-view-request-create/src/common/utils/configuration/fields/multi-checkbox';
import { withControlledFormComponentValue } from 'view/common/with-controlled-form-component-value';
export interface Item {
	label: string;
	value: string;
}
export interface Props extends FieldFormProps<string[]> {
	items: Item[];
	defaultValue?: string[];
	value?: string[];
}

class CustomCheckboxGroup extends React.PureComponent<Props> {
	checkedValues: string[];

	constructor(props: Props) {
		super(props);
		this.checkedValues = props.defaultValue || [];
	}

	onChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
		if (this.props.onChange) {
			const currentValue = e.currentTarget.value;
			const selectedValues = this.props.value ?? this.checkedValues;
			const nextValues = selectedValues.includes(currentValue)
				? selectedValues.filter((value) => value !== currentValue)
				: [...selectedValues, currentValue];
			this.checkedValues = nextValues;
			if (this.props.value !== undefined) {
				const selectedItems = this.props.items.filter((item) => nextValues.includes(item.value));

				this.props.onChange(this.props.id, nextValues, false, {
					rawObject: selectedItems,
					rawValue: selectedItems,
				});
				return;
			}

			this.props.onChange(this.props.id, nextValues);
		}
	};
	render() {
		const { label, required, description, id, items, errorMessage, disabled, value } = this.props;
		const selectedValues = value ?? this.checkedValues;

		return (
			<FieldBase
				htmlFor={id}
				labelId={id}
				label={label}
				required={required}
				description={description}
				errorMessage={errorMessage}
			>
				<CheckboxGroup
					role="group"
					aria-labelledby={id}
					aria-describedby={`${id}-field-description`}
				>
					{items.map((item) => (
						<Checkbox
							isDisabled={disabled}
							key={item.label}
							name={item.label}
							label={item.label}
							value={item.value}
							{...(value === undefined
								? { defaultChecked: this.checkedValues.includes(item.value) }
								: { isChecked: selectedValues.includes(item.value) })}
							onChange={this.onChange}
						/>
					))}
				</CheckboxGroup>
			</FieldBase>
		);
	}
}

export const ControlledCheckboxGroup = withControlledFormComponentValue<Item[] | string[]>(
	(_field: string, value: string[]) => value,
	normalizeMultiCheckboxValue,
)(CustomCheckboxGroup);

export default CustomCheckboxGroup;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const CheckboxGroup = styled.div`
	display: flex;
	flex-direction: column;
`;
